// src/App.js
import React from "react";
import CategoryForm from "./CategoryForm";
import CategoryList from "./CategoryList";
import { useCheckAccess } from "../../utils/Utilities";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import { Helmet } from "react-helmet-async";

const CategoryAdmin = () => {
    useCheckAccess('ConfigRW');
    return (
        <>
            <Navbar />
            <Helmet>
                <title>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள் | Category Form</title>
                <link rel="canonical" href="/family/create" />
            </Helmet>
            <Breadcrumbs /><br />
            <CategoryForm />
            <CategoryList />

            <Footer />
        </>
    );
}

export default CategoryAdmin;
